import {Component, OnInit} from '@angular/core';
import {Banner} from 'src/app/modelos/banner';
import {Path} from 'src/app/util/path';
import {Dispensa} from 'src/app/modelos/dispensa';
import {AvisoDispensaService} from 'src/app/services/aviso-dispensa.service';
import { NoticiaService } from 'src/app/services/noticia.service';
import { Noticia } from 'src/app/modelos/noticia';
import {Setor} from '../../modelos/setor';

@Component({
    selector: 'app-pagina-principal',
    templateUrl: './pagina-principal.component.html',
    styleUrls: ['./pagina-principal.component.scss'],
    standalone: false
})
export class PaginaPrincipalComponent implements OnInit {

    noticiasSlideshow: Noticia[] = [];
    ultimasNoticias: Noticia[] = [];

    pathCanaisAtendimento = Path.CANAIS_ATENDIMENTO;
    pathEstagios = Path.PAGINA_ESTAGIOS;
    pathNisia = Path.SELECAO_NISIA;
    paghExpurgos = Path.EXPURGOS_INFLACIONARIOS;
    pathAjuizamentoSemAdvogado = Path.JUIZADOS_ESPECIAIS.caminho + '/' + Path.ATERMACAO_ONLINE.caminho;
    pathBuscaProcessual = Path.BUSCA_PROCESSUAL;
    pathTransparencia = Path.TRANSPARENCIA;
    pathQuintaJuridica = Path.QUINTA_JURIDICA;
    pathQuintaJuridicaCaminho = Path.QUINTA_JURIDICA.caminho;
    pathJurisdicao = Path.JURISDICAO;
    pathJuizadosEspeciais = Path.JUIZADOS_ESPECIAIS;
    pathCertidaoNegativa = Path.CERTIDAO_NEGATIVA;
    pathImprensa = Path.IMPRENSA.caminho + '/' + Path.NOTICIAS.caminho;
    pathConveniosAcordos = Path.CONVENIOS;
    pathEstagio = '/administracao/selecoes-concursos/' + Path.ESTAGIOS.caminho;
    pathINTRANETPaginasSetoriais = 'pagina-setor-interno-conteudo?nomePagina='
    aviso: any;
    dispensa: any;

    filtro: Filtro = {
        filtroSetor: undefined,
        filtroTitulo: '',
        filtroObjeto: '',
        filtroProcesso: '',
        filtroDataLimite: '',
        filtroStatus: 'ABERTO',
    };

    banners: Banner[] = [
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/carta-de-servico.png',
            linkPagina: '/carta-de-servicos',
            descricao: 'Carta de serviços',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/cooperacao-judiciaria.png',
            linkPagina: '/cooperacao-judiciaria',
            descricao: 'Cooperação',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/plantao-judiciario.png',
            linkPagina: '/plantao-judiciario',
            descricao: 'Plantão judiciário',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/cadastro-de-peritos.png',
            linkPagina: '/ajg/',
            descricao: 'Cadastro de peritos',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/informe-tr.png',
            linkPagina: Path.PAGINAS_SETORIAIS.caminho + '/' + Path.SETOR.caminho + '?setor=18',
            descricao: 'Informe turma recursal',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/esmafe.png',
            linkPagina: 'https://esmafe.jfrn.jus.br/esmafe/',
            descricao: 'Esmafe',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/centro-de-conciliacao.png',
            linkPagina: Path.PAGINAS_SETORIAIS.caminho + '/' + Path.SETOR.caminho + '?setor=21',
            descricao: 'Centro de conciliação',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/centro-de-inteligencia.png',
            linkPagina: 'https://centrodeinteligencia.jfrn.jus.br/jfrn/#/',
            descricao: 'Centro de inteligência',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/jfrn-sustentavel-2023-06.png',
            linkPagina: '/jfrn-sustentavel',
            descricao: 'JFRN Sustentável',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/judsaude.png',
            linkPagina: Path.JUD_SAUDE.caminho,
            descricao: 'Judsaude',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/sei.png',
            linkPagina: '/sei',
            descricao: 'SEI!',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/jf-media.png',
            linkPagina: '/jf-media',
            descricao: 'JF Media',
            ehComissao: false
        },
        /*{
            ampliar: false,
            linkImagem: 'assets/img/banners/gmf.png',
            linkPagina: 'https://gmf.jfrn.jus.br/gmf/',
            descricao: 'GMF',
            ehComissao: false
        },
        {
            ampliar: true,
            linkImagem: 'assets/img/banners/ouvidoria-criminal.png',
            linkPagina: 'https://gmf.jfrn.jus.br/gmf/ouvidoria.xhtml',
            descricao: 'Ouvidoria criminal',
            ehComissao: false
        },*/

        {
            ampliar: false,
            linkImagem: 'assets/img/banners/lab-i9.png',
            linkPagina: 'https://i9.jfrn.jus.br',
            descricao: 'Laboratório de Inovação',
            ehComissao: false
        },
        /* {
            linkImagem: 'assets/images/memorial.png',
            linkPagina: 'https://memorial.jfrn.jus.br',
            descricao: 'Memorial da Justiça Federal do RN'
        }, */
        {
            ampliar: false,
            linkImagem: 'assets/images/memorial.png',
            linkPagina: 'https://memorial.jfrn.jus.br',
            descricao: 'Memorial da Justiça Federal do RN',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/ceav.png',
            linkPagina: '/ceav',
            descricao: 'Centro Especializado de Acolhimento à Vítima',
            ehComissao: false
        },
        {
            ampliar: false,
            linkImagem: 'assets/img/banners/comissao-acessibilidade.png',
            linkPagina: '/acessibilidade-e-inclusao',
            descricao: 'Comissão de Acessibilidade',
            ehComissao: false
        },
       {
            ampliar: true,
            linkImagem: 'assets/img/banners/cpamas.png',
            linkPagina: 'comissao-cpamas',
            descricao: 'Comissão de Prevenção e Enfrentamento do Assédio Moral e do Assédio Sexual - CPAMAS',
            ehComissao: true
       },

      {
        ampliar: true,
        linkImagem: 'assets/img/banners/gams.png',
        linkPagina: '/comissao-gams',
        descricao: 'Grupo de Apoio e Assistência às Magistradas, Servidoras e Colaboradoras da Seção Judiciária do Rio Grande do Norte em Situação de Violência Doméstica e Familiar – GAMS',
        ehComissao: true
      },

      {
        ampliar: false,
        linkImagem: 'assets/img/banners/cejure.png',
        linkPagina: '/cejure-justica-restaurativa',
        descricao: 'Centro de Justiça Restaurativa da JFRN',
        ehComissao: false
      }

    ];

    constructor(
        private noticiaService: NoticiaService,
        private avisoDispensaService: AvisoDispensaService
    ) {
        avisoDispensaService.buscarRegistros(0, 10, this.filtro).subscribe((data: Dispensa) => {
            this.dispensa = data;
            this.aviso = this.dispensa.totalElements > 0;
        });
        noticiaService.getNoticiasPaginaInicial(0, 6).toPromise().then((res: any) => {
            this.ultimasNoticias = res.content;
          });
    }

    indices(i: number): any {
        return Array.from({length: Math.ceil(i)}, (v, k) => k * 3);
    }

    indicadores(i: number): any {
        return Array.from({length: Math.ceil(i)}, (v, k) => k++);
    }

    ngOnInit(): void {

    }

    getHeightImage(item: Banner){
        if(item.ampliar){
            return "100px";
        }
        return "90px"
    }

  getWidthImage(item: Banner){
    if(item.ampliar){
      return "100%";
    }
    return "80%"
  }

}

export class Filtro {
  filtroSetor: Setor | undefined = undefined;
  filtroTitulo: string | undefined = undefined;
  filtroObjeto: string | undefined = undefined;
  filtroProcesso: string | undefined = undefined;
  filtroDataLimite: any | undefined = undefined;
  filtroStatus: string | undefined = undefined;
}

